import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		dialogTitle: {
			padding: "1rem",
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
		},
closeButton: {
			padding: 0,
			margin: 0,
			height: "auto",
			"&:hover": {
				backgroundColor: "transparent",
			},
		},
		dialogContent: {
			padding: "1.5rem 1rem",
			backgroundColor: "white",
		},
		formContainer: {
			display: "flex",
			flexDirection: "column",
			gap: "1.5rem",
		},
		helperText: {
			margin: "0.25rem 0.875rem 0",
			fontSize: "0.75rem",
			color: theme.palette.error.main,
			fontFamily: theme.typography.fontFamily,
		},
		autocomplete: {
			"& .MuiOutlinedInput-root": {
				backgroundColor: "white",
				borderRadius: 8,
				"& fieldset": {
					borderColor: theme.palette.custom.border,
					borderWidth: 1,
				},
				"&:hover fieldset": {
					borderColor: theme.palette.custom.border,
				},
				"&.Mui-focused fieldset": {
					borderColor: theme.palette.custom.primary,
					borderWidth: 1,
				},
			},
			"& .MuiInputLabel-root": {
				fontSize: "0.875rem",
				color: theme.palette.custom.textSecondary,
				fontWeight: 400,
				fontFamily: theme.typography.fontFamily,
			},
		},
		dateTimeRow: {
			display: "flex",
			gap: "0.5rem",
			"& > div": {
				flex: 1,
			},
		},
		dateLabel: {
			fontSize: "0.875rem",
			color: theme.palette.custom.textSecondary,
			fontWeight: 400,
			fontFamily: theme.typography.fontFamily,
			"& .MuiInputLabel-asterisk": {
				color: theme.palette.error.main,
			},
		},
		dateInput: {
			backgroundColor: "white",
			borderRadius: 8,
			height: 52,
			fontSize: "1rem",
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
			"& fieldset": {
				borderColor: theme.palette.custom.border,
				borderWidth: 1,
			},
			"&:hover fieldset": {
				borderColor: theme.palette.custom.border,
			},
			"&.Mui-focused fieldset": {
				borderColor: theme.palette.custom.primary,
				borderWidth: 1,
			},
		},
		priorityRow: {
			display: "flex",
			alignItems: "center",
			gap: "1rem",
		},
		switch: {
			"& .MuiSwitch-switchBase": {
				color: "#b9b9b9",
			},
			"& .MuiSwitch-switchBase.Mui-checked": {
				color: theme.palette.custom.primary,
			},
			"& .MuiSwitch-track": {
				backgroundColor: "#b9b9b9",
			},
		},
		priorityLabel: {
			fontSize: "1rem",
			lineHeight: "20px",
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
		},
		buttonRow: {
			display: "flex",
			justifyContent: "flex-end",
			gap: "0.5rem",
			marginTop: "1rem",
		},
		saveButton: {
			backgroundColor: theme.palette.primary.main,
			color: "white",
			textTransform: "none",
			fontFamily: theme.typography.fontFamily,
			fontWeight: 600,
		},
		cancelButton: {
			borderColor: theme.palette.primary.main,
			color: theme.palette.primary.main,
			textTransform: "none",
			fontFamily: theme.typography.fontFamily,
			fontWeight: 600,
		},
	} satisfies Record<string, CSSObject>);
